import { sharedEnvironment } from './environment.shared'

export const environment = Object.assign(sharedEnvironment, {
  production: true,
  apiURL: 'https://api.gea.at/webshop/v1',
  apiURL_SSR: 'http://webshop-api:8080/webshop/v1',
  wsURL: 'wss://api.gea.at/webshop/v1',
  imagesURL: 'https://assets.gea.at',
  publicStripeKey: 'pk_live_cZXIMA49YpbaLS27JPfyfFtX',
  paypalClientId: 'AW3gsWebhhB6Ya1RdLh39ks8ZpmvWJ_8Al9gZWR05nCC3f56EVXqv5Sj-YregbV2bOkUCHFqrLnHydQh',
  cmsBaseUrl: 'https://gea-waldviertler.at',
  cmsBaseUrl_SSR: 'http://cms-varnish',
  cmsMediaUrl: 'https://gea-waldviertler.at/media',
  productImagesRoot: 'https://gea-waldviertler.at',
  matomoOwnProviderUrl: 'https://matomo.gea.at',
  matomoOwnProviderId: 1,
  matomoScriptUrl: 'https://matomo.gea.at/matomo.js',
  sentryUserFeedback: false,
  sentryDSN: "https://1ccd4ab53896c7791c459c73a2ca5697@sentry.gea.at/7",
  sentryEnvironment: "production"
})
